import MuiAlertTitle from "@mui/material/AlertTitle";
const AlertTitle = MuiAlertTitle;
export default AlertTitle;
